import React from "react";
import { useTranslation } from "react-i18next";

// Custom icon components
const EmailIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
  </svg>
);

const LocationIcon = () => (
  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const LinkedInIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const TwitterIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
  </svg>
);

const GitHubIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
  </svg>
);

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-gradient-to-br from-blue-900 to-blue-600 pt-16 pb-8 mt-auto text-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2 mb-8">
            <h3 className="text-xl font-bold text-white mb-4">
              {t("homepage.footer.company.name", "AETI Industries")}
            </h3>
            <p className="text-white/80 mb-6 leading-relaxed">
              {t("homepage.footer.company.description", "Transforming industries through innovative IoT and edge computing solutions.")}
            </p>
            
            <div className="space-y-4">
              <div className="flex items-center">
                <LocationIcon />
                <span className="ml-2 text-white/80">
                  {t("homepage.footer.address", "Algiers, Algeria")}
                </span>
              </div>
              
              <div className="flex items-center">
                <PhoneIcon />
                <span dir="ltr" className="ml-2 text-white/80">
                  {t("homepage.footer.phone", "+213 (0)698 30 44 50")}
                </span>
              </div>
              
              <div className="flex items-center">
                <EmailIcon />
                <span className="ml-2 text-white/80">
                  {t("homepage.footer.email", "contact@alsaqr.io")}
                </span>
              </div>
            </div>
          </div>

          {/* Solutions */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-white mb-4">
              {t("homepage.footer.solutions.title", "Solutions")}
            </h3>
            <div className="space-y-2">
              <a href="#segments" className="block text-white/80 hover:text-white transition-colors">
                {t("homepage.footer.solutions.iot", "IoT Platform")}
              </a>
              <a href="#segments" className="block text-white/80 hover:text-white transition-colors">
                {t("homepage.footer.solutions.fleet", "Fleet Management")}
              </a>
              <a href="#segments" className="block text-white/80 hover:text-white transition-colors">
                {t("homepage.footer.solutions.edge", "Edge Computing")}
              </a>
            </div>
          </div>

          {/* Industries */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-white mb-4">
              {t("homepage.footer.industries.title", "Industries")}
            </h3>
            <div className="space-y-2">
              <a href="#use-cases" className="block text-white/80 hover:text-white transition-colors">
                {t("homepage.footer.industries.logistics", "Logistics")}
              </a>
              <a href="#use-cases" className="block text-white/80 hover:text-white transition-colors">
                {t("homepage.footer.industries.energy", "Energy")}
              </a>
              <a href="#use-cases" className="block text-white/80 hover:text-white transition-colors">
                {t("homepage.footer.industries.manufacturing", "Manufacturing")}
              </a>
              <a href="#use-cases" className="block text-white/80 hover:text-white transition-colors">
                {t("homepage.footer.industries.healthcare", "Healthcare")}
              </a>
            </div>
          </div>

          {/* Company */}
          <div className="mb-8">
            <h3 className="text-lg font-semibold text-white mb-4">
              {t("homepage.footer.company.title", "Company")}
            </h3>
            <div className="space-y-2">
              <a href="#contact" className="block text-white/80 hover:text-white transition-colors">
                {t("homepage.footer.company.contact", "Contact Us")}
              </a>
              <a href="#trial" className="block text-white/80 hover:text-white transition-colors">
                {t("homepage.footer.company.trial", "Free Trial")}
              </a>
              <a href="#dashboard-preview" className="block text-white/80 hover:text-white transition-colors">
                {t("homepage.footer.company.demo", "Demo")}
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 mt-8 pt-8">
          {/* Bottom Section */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/80 text-sm">
              {t("homepage.footer.copyright", "© {{year}} AETI Industries. All rights reserved.", { year: new Date().getFullYear() })}
            </p>
            
            <div className="flex gap-4">
              <a href="#" className="text-white/80 hover:text-yellow-400 transition-colors">
                <LinkedInIcon />
              </a>
              <a href="#" className="text-white/80 hover:text-yellow-400 transition-colors">
                <TwitterIcon />
              </a>
              <a href="#" className="text-white/80 hover:text-yellow-400 transition-colors">
                <GitHubIcon />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
